<template>
  <div v-if="active" class="imot form-modal-container" :class="textColorClass" ref="modal" v-body-scroll-lock="true">
    <div class="form-modal">
      <div class="form-modal__header">
        <button class="form-modal__closeButton" @click="close()"></button>
        <h1 class="form-modal__title">{{ title }}</h1>
      </div>
      <!-- .modal__header -->
      <div class="form-modal__content-container">
        <div class="form-modal__vehicle-container">
          <div class="form-modal__vehicle">
            <div class="form-modal__vehicle__title">
              <strong>{{ vehicle.properties.brand }}</strong> {{ vehicle.properties.model }}
            </div>
            <div class="form-modal__vehicle__image">
              <img :src="vehicle.images[0]" />
            </div>
            <div class="form-modal__vehicle__details">
              <div class="form-modal__vehicle__details__price">
                <span v-if="vehicle.properties.price" class="detail__info__price"
                  >{{ vehicle.properties.price | toEUR }}
                  <span
                    v-if="vehicle.properties.priceInclTax === false && vehicle.properties.btwMarge === 'BTW'"
                    class="detail__info__price__tax"
                    >{{ $t('vehicle.exclTax') }}</span
                  >
                </span>

                <span v-if="vehicle.properties.priceFinanceAmount" class="detail__info__monthlyPrice">
                  {{ $t('vehicle.finance.from') }} {{ vehicle.properties.priceFinanceAmount | round | toEUR }}
                  {{ $t('vehicle.finance.perMonth') }}
                </span>
              </div>
              <ul class="detail__info__list form-modal__vehicle__details__info">
                <li v-if="vehicle.properties.year" class="detail__info__item detail__info__item--year">
                  <span class="detail__info__label">{{ $t('vehicle.year') }}</span>
                  <span class="detail__info__value">{{ vehicle.properties.year }}</span>
                </li>
                <!-- .detail__info__item -->
                <li v-if="vehicle.properties.mileage" class="detail__info__item detail__info__item--mileage">
                  <span class="detail__info__label">{{ $t('vehicle.mileage') }}</span>
                  <span class="detail__info__value"
                    >{{ vehicle.properties.mileage | thousandSeparated }} {{ vehicle.properties.mileageUnit }}</span
                  >
                </li>
                <!-- .detail__info__item -->
                <li v-if="vehicle.properties.fuelType" class="detail__info__item detail__info__item--fuelType">
                  <span class="detail__info__label">{{ $t('vehicle.fuelType') }}</span>
                  <span class="detail__info__value">{{ vehicle.properties.fuelType }}</span>
                </li>
                <!-- .detail__info__item -->
                <li v-if="vehicle.properties.transmission" class="detail__info__item detail__info__item--transmission">
                  <span class="detail__info__label">{{ $t('vehicle.transmission') }}</span>
                  <span class="detail__info__value">{{ vehicle.properties.transmission }}</span>
                </li>
                <!-- .detail__info__item -->
              </ul>
              <!-- .detail__info__list -->
            </div>
          </div>
        </div>
        <!-- .modal__vehicle -->
        <div class="form-modal__content">
          <slot></slot>
        </div>
        <!-- .modal__content -->
      </div>
    </div>
    <!-- .modal -->
  </div>
</template>

<script>
export default {
  name: 'modal',
  props: ['title', 'active', 'vehicle'],
  computed: {
    textColorClass: function () {
      return this.$store.state.settings.general !== null ? '-mainTextColor-' + this.$store.state.settings.general.mainTextColor : ''
    },
  },
  watch: {
    active(isModalActive) {
      if (isModalActive === true) {
        this.$nextTick(function () {
          const modalEl = this.$refs.modal
          modalEl.parentNode.removeChild(modalEl)
          document.body.appendChild(modalEl)
        })
      }
    },
  },
  components: {},
  methods: {
    close() {
      this.$emit('modalClosed', true)
    },
  },
}
</script>
